import { Navbar } from "../shared/components/navbar/Navbar.js";
import { LcapiiService } from "../shared/services/LcapiiService.js";
import { TemplateEngine } from "../shared/utils/TemplateEngine.js";
import { operacionesPermitidas } from "../operaciones/permisos.js";
import homeTemplate from "./templates/home.html?raw";

// La home de la app anterior solo mostraba el nombre del usuario. Acá lista las
// secciones habilitadas como accesos directos: en el celular, que es donde se
// usa, evita tener que abrir el menú hamburguesa para todo.

export const HomeController = {
  render() {
    const permitidas = operacionesPermitidas();

    const contenido = TemplateEngine.render(homeTemplate, {
      nombres: LcapiiService.sesion().nombres || "",
      operaciones: permitidas.map((op) => ({
        clave: op.clave,
        titulo: op.titulo,
        icono: op.icono,
      })),
      hayOperaciones: permitidas.length > 0,
    });

    document.getElementById("app").innerHTML = Navbar.render("") + contenido;
    Navbar.bind();
  },
};
